import { Layout } from "ant-design-vue";
const { Sider, Content, Footer, Header, ...other } = Layout;
const YwLayout = {
  ...other,
  name: "YwLayout",
  Sider: {
    ...Sider,
    name: "YwLayoutSider",
  },
  Content: {
    ...Content,
    name: "YwLayoutContent",
  },
  Footer: {
    ...Footer,
    name: "YwLayoutFooter",
  },
  Header: {
    ...Header,
    name: "YwLayoutHeader",
  },
};
YwLayout.install = function (Vue) {
  Vue.component(YwLayout.name, YwLayout);
  Vue.component(YwLayout.Header.name, Header);
  Vue.component(YwLayout.Sider.name, Sider);
  Vue.component(YwLayout.Content.name, Content);
  Vue.component(YwLayout.Footer.name, Footer);
};

export default YwLayout;

